import { escapeHTML } from "../XssFilter.js";
import { isString, isNull, isRawObject, isArray } from "../TypeAssert.js";
function sanitizeValue(input) {
  if (isString(input)) {
    return escapeHTML(input);
  }
  if (isNull(input) || !isRawObject(input) && !isArray(input)) {
    return input;
  }
  for (const key in input) {
    const currentValue = input[key];
    switch (typeof currentValue) {
      case "string":
        input[key] = escapeHTML(currentValue);
        break;
      case "object":
        input[key] = sanitizeValue(currentValue);
    }
  }
  return input;
}
export {
  sanitizeValue
};
//# sourceMappingURL=SanitizeValue.js.map
